import styled from 'styled-components'

export const ScrollToTopStyle = styled.div`
    display: inline-flex;
    border: 1px solid rgba(32, 32, 32, 0.1);
    box-shadow: 0px 1px 2px rgba(32, 32, 32, 0.05);
    box-sizing: border-box;
    border-radius: 50%;
    cursor: pointer;
    padding: 17px 15px;
    position: fixed;
    bottom: ${(props) => {
    return props.bottom ? props.bottom : '32px'
  }};
    right: 32px;
`
